/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.51   Rana simulation core release: 3.7.3   deployed on:  10:12AM (UTC) on September 07, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ForcingSubstance } from "./ForcingSubstance";
import {
  ForcingSubstanceFromJSON,
  ForcingSubstanceFromJSONTyped,
  ForcingSubstanceToJSON,
  ForcingSubstanceToJSONTyped,
} from "./ForcingSubstance";

/**
 *
 * @export
 * @interface UploadWithSubstances
 */
export interface UploadWithSubstances {
  /**
   *
   */
  substances?: Array<ForcingSubstance>;
  /**
   *
   */
  readonly putUrl?: string;
  /**
   *
   */
  filename: string;
  /**
   *
   */
  readonly status?: string;
}

/**
 * Check if a given object implements the UploadWithSubstances interface.
 */
export function instanceOfUploadWithSubstances(value: object): value is UploadWithSubstances {
  if (!("filename" in value) || value["filename"] === undefined) return false;
  return true;
}

export function UploadWithSubstancesFromJSON(json: any): UploadWithSubstances {
  return UploadWithSubstancesFromJSONTyped(json, false);
}

export function UploadWithSubstancesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UploadWithSubstances {
  if (json == null) {
    return json;
  }
  return {
    substances:
      json["substances"] == null
        ? undefined
        : (json["substances"] as Array<any>).map(ForcingSubstanceFromJSON),
    putUrl: json["put_url"] == null ? undefined : json["put_url"],
    filename: json["filename"],
    status: json["status"] == null ? undefined : json["status"],
  };
}

export function UploadWithSubstancesToJSON(json: any): UploadWithSubstances {
  return UploadWithSubstancesToJSONTyped(json, false);
}

export function UploadWithSubstancesToJSONTyped(
  value?: Omit<UploadWithSubstances, "putUrl" | "status"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    substances:
      value["substances"] == null
        ? undefined
        : (value["substances"] as Array<any>).map(ForcingSubstanceToJSON),
    filename: value["filename"],
  };
}
